import { Link as A } from 'react-router-dom';
import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, ClassName, Gap, TestId {
  /** The link's display mode */
  display?: 'inline' | 'block' | 'inline-block' | 'flex';

  /** The link's href/url */
  href: string;

  /** The link's target (`_blank` / `_self`) */
  target?: '_self' | '_blank';

  /** Style the link as link / link in a text / button (default: `textlink`) */
  variant?: 'link' | 'textlink' | 'button';
}

/** Renders a link */
const Link = ({
  children,
  className = '',
  display = 'inline-block',
  gap = 'none',
  href,
  target = '_self',
  variant = 'textlink',
  testId,
}: Props): React.ReactElement => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const LinkElement = (props: any): React.ReactElement =>
    // eslint-disable-next-line react/jsx-props-no-spreading, jsx-a11y/anchor-has-content
    href.startsWith('http') ? <a {...props} /> : <A {...props} />;

  return (
    <LinkElement
      className={`
        ${display}
        gap--${gap}
        ${variant === 'link' ? 'link' : ''}
        ${variant === 'textlink' ? 'link link--text' : ''}
        ${variant === 'button' ? 'btn' : ''}
        ${className}
      `}
      to={href}
      href={href}
      rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
      target={target}
      data-testid={testId}
    >
      {children}
    </LinkElement>
  );
};

export default Link;
